import { wrapEmail, htmlEscape, paragraphsToHtml, ctaButton, heroImage, assertNoUnsubstitutedTokens } from './_shared.js';

export default {
  id: 'caseStudy',
  name: 'Product / Case Study',
  description: 'Hero + project title + intro + project image + body + CTA. Showcase a washroom installation.',
  slots: [
    { id: 'preheader',    label: 'Preview text',      type: 'text',     optional: true, maxLen: 140 },
    { id: 'hero',         label: 'Hero image URL',    type: 'image',    optional: true },
    { id: 'eyebrow',      label: 'Eyebrow label',     type: 'text',     optional: true, maxLen: 40,
      hint: 'e.g. "Case study" or the sector ("Healthcare", "Education").' },
    { id: 'projectTitle', label: 'Project title',     type: 'text',     optional: false, maxLen: 100 },
    { id: 'location',     label: 'Location / Client', type: 'text',     optional: true, maxLen: 80 },
    { id: 'intro',        label: 'Intro paragraph',   type: 'longtext', optional: false },
    { id: 'projectImage', label: 'Project image URL', type: 'image',    optional: true },
    { id: 'body',         label: 'Body',              type: 'longtext', optional: false },
    { id: 'buttonLabel',  label: 'Button label',      type: 'text',     optional: true, pairsWith: 'buttonUrl' },
    { id: 'buttonUrl',    label: 'Button URL',        type: 'url',      optional: true, pairsWith: 'buttonLabel' },
  ],
  render(content, branding, footer, options) {
    const c = content || {};
    const ff = (branding && branding.fontFamily) || 'Arial';
    const accent = (branding && branding.primaryColour) || '#00897b';
    const hidden = new Set(c.slotsHidden || []);
    const inner = `
      ${!hidden.has('hero') && c.hero ? heroImage(c.hero, c.projectTitle) : ''}
      ${!hidden.has('eyebrow') && c.eyebrow ? `<p style="margin: 0 0 8px; font-family: ${ff}, Helvetica, Arial, sans-serif; font-size: 12px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase; color: ${htmlEscape(accent)};">${htmlEscape(c.eyebrow)}</p>` : ''}
      <h1 class="headline dark-text" style="margin: 0 0 8px; font-family: ${ff}, Helvetica, Arial, sans-serif; font-size: 28px; font-weight: 700; line-height: 1.22; letter-spacing: -0.015em; color: #111827;">${htmlEscape(c.projectTitle || '')}</h1>
      ${!hidden.has('location') && c.location ? `<p class="muted" style="margin: 0 0 20px; font-family: ${ff}, Helvetica, Arial, sans-serif; font-size: 14px; color: #6b7280;">${htmlEscape(c.location)}</p>` : ''}
      ${paragraphsToHtml(c.intro, ff)}
      ${!hidden.has('projectImage') && c.projectImage ? `<div style="margin-top: 8px;">${heroImage(c.projectImage, c.projectTitle)}</div>` : ''}
      ${paragraphsToHtml(c.body, ff)}
      ${!hidden.has('buttonLabel') && c.buttonLabel && c.buttonUrl ? ctaButton(c.buttonLabel, c.buttonUrl, branding) : ''}
    `;
    const html = wrapEmail(inner, branding, footer, {
      ...options,
      preheader: c.preheader || c.intro?.split('\n')[0] || c.projectTitle,
    });
    assertNoUnsubstitutedTokens(html);
    return html;
  },
};
